import { render, staticRenderFns } from "./FormulaImport.vue?vue&type=template&id=67f046e4"
import script from "./FormulaImport.vue?vue&type=script&lang=js"
export * from "./FormulaImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports